import React from 'react';
import { useTranslation } from '@ikea-customer-self-serve/gatsby-plugin-translations';
import Loading, { LoadingBall } from '@ingka/loading';
import styled from 'styled-components';
import { SparePart } from '../interfaces/Item';
import { AspectRatioImage } from './AspectRatioImage';
import HighlightText from './HighlightText';

interface ListItemProps {
  items: SparePart[];
  onClickItem: (item: SparePart) => void;
  highlight: string;
}
const Image = styled.div`
  width: 75px;
  height: auto;
  padding-right: 8px;
  min-width: auto;
  margin-inline-end: 10px;
`;
const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  word-break: break-all;
`;
const StyledHighlightText = styled(HighlightText)``;
const SearchResultItem = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  overflow: hidden;
  height: 75px;
  border: 0;
  width: 100%;
  background: transparent;
  padding: 0;
  margin: 0;
  :hover {
    ${StyledHighlightText} {
      text-decoration: underline;
    }
  }
`;
const SearchResultListWrapper = styled.li``;
export const ListItems: React.FC<ListItemProps> = ({
  items,
  onClickItem,
  highlight,
}): JSX.Element => {
  const result = items.map((item) => {
    const { id, imageSrc } = item;
    return (
      <SearchResultListWrapper key={item.id} className="item">
        <SearchResultItem key={id} onClick={(): void => onClickItem(item)}>
          <Image>
            <AspectRatioImage src={imageSrc} alt="" />
          </Image>
          <FlexContainer>
            <StyledHighlightText text={`${id}`} highlight={highlight} />
          </FlexContainer>
        </SearchResultItem>
      </SearchResultListWrapper>
    );
  });

  return <>{result}</>;
};

interface SearchForItemsProps {
  search: string;
  onClickItem: (item: SparePart | undefined) => void;
  loading: boolean;
  items: SparePart[];
}

export const DisplaySearchItems: React.FC<SearchForItemsProps> = ({
  search,
  onClickItem,
  loading,
  items,
}): JSX.Element | null => {
  const { t } = useTranslation();
  if (loading) {
    return (
      <Loading
        text={t('spareParts.search.searchingFor', {
          search,
        })}
      >
        <LoadingBall />
      </Loading>
    );
  }
  if (!items.length) {
    return null;
  }
  return (
    <ListItems items={items} highlight={search} onClickItem={onClickItem} />
  );
};
